import {
  BooleanField,
  Datagrid,
  DateField,
  List,
  NumberField,
  ReferenceField,
  TextField,
  TextInput,
  ListActions,
} from 'react-admin';
import { QualifyButton } from './QualifyButton';
import { CreateDialog } from '@react-admin/ra-form-layout';
import { QuoteCreate } from './QuoteCreate';

const searchFilters = [
  <TextInput source="contact_name@ilike" label="Name" alwaysOn />,
  <TextInput source="email@ilike" label="Email" alwaysOn />,
  <TextInput source="phone_number@ilike" label="Phone" alwaysOn />,
];

export const QuotesList = () => (
  <>
    <List
      filters={searchFilters}
      sort={{ field: 'created_at', order: 'DESC' }}
      perPage={50}
      actions={<ListActions hasCreate />}
    >
      <Datagrid rowClick="show">
        <TextField source="contact_name" label="Name" />
        <TextField source="phone_number" label="Phone" />
        <TextField source="email" label="Email" />
        <DateField
          source="created_at"
          options={{
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          }}
        />
        <BooleanField source="qualified" />
        <ReferenceField source="funeral_id" reference="funerals" link="show">
          <NumberField source="id" />
        </ReferenceField>
        <TextField source="language" />
        <QualifyButton />
      </Datagrid>
    </List>
    <CreateDialog fullWidth maxWidth="sm">
      <QuoteCreate />
    </CreateDialog>
  </>
);
